<template>
    <b-card :title="item.name" class="border-0">
        <div class="card-text">
            <div v-html="item.description" class="mb-3"></div>
            <b-row v-if="!!item.internal_management_photos.length">
                <b-col v-for="photo in images" :key="photo.id" class="mb-2">
                    <b-media no-body>
                        <b-img :src="photo.photo_url" style="max-width: 100%;"></b-img>
                    </b-media>
                </b-col>
            </b-row>
            <br />
            <b-row>
                <h4>Documentos:</h4>
            </b-row>
            <b-row>
                <b-col cols="12">
                    <div v-for="file in files" :key="file.id">
                        <ul>
                            <li>
                                <b-button variant="link" @click="downloadFile(file)">
                                    {{file.name}}
                                    <i class="fa fa-download"></i>
                                </b-button>
                            </li>
                        </ul>
                        <a :href="file.photo_url" target="_blank">{{file.photo_url}}</a>
                    </div>
                </b-col>
            </b-row>
        </div>
    </b-card>
</template>
<script>
export default {
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    computed: {
        images() {
            if (!!this.item.internal_management_photos) {
                return this.item.internal_management_photos.filter(
                    item => item.type === 'image'
                )
            }
        },
        files() {
            if (!!this.item.internal_management_photos) {
                return this.item.internal_management_photos.filter(
                    item => item.type === 'file'
                )
            }
        },
    },
    methods: {
        downloadFile(item) {
            window.open(
                `web/v1/internal-management/${item.id}/download`,
                '_blank'
            )
        },
    },
}
</script>
<style>
.url {
    font-size: 14px;
}
</style>